// The founding offer: a shop on a Founding plan gets its first month free
// (Mazin, 4 Nov 2026; it used to be three months). When a super admin starts
// a Founding subscription in the console, the end date is filled in as one
// month from today (Oman time); it can still be changed before saving.
export const FOUNDING_FREE_MONTHS = 1;

export const isFoundingPlan = (plan) => /^founding\b/i.test(String(plan?.name ?? "").trim());

// "2026-11-04" plus 1 month is "2026-12-04". A day the later month doesn't have
// becomes its last day: 31 Jan plus 1 month is 28 Feb (29 in a leap year).
export const addMonths = (yyyyMmDd, months) => {
  const [year, month, day] = yyyyMmDd.split("-").map(Number);
  const first = new Date(Date.UTC(year, month - 1 + months, 1));
  const lastDay = new Date(Date.UTC(first.getUTCFullYear(), first.getUTCMonth() + 1, 0)).getUTCDate();
  first.setUTCDate(Math.min(day, lastDay));
  return first.toISOString().slice(0, 10);
};

export const foundingEndDate = (todayYyyyMmDd) => addMonths(todayYyyyMmDd, FOUNDING_FREE_MONTHS);
